<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-center justify-space-between mb-4">
                        <div class="d-flex align-center" style="gap: 10px;">
                            <v-chip color="warning" variant="tonal">
                                Pendientes pago CJ: {{ cjPending.total }}
                            </v-chip>
                            <v-chip :color="cjWebhookLogs.total > 0 ? 'error' : 'success'" variant="tonal">
                                Incidencias webhook CJ: {{ cjWebhookLogs.total }}
                            </v-chip>
                            <v-btn color="secondary" variant="outlined" size="small" @click="resetFilters">
                                Limpiar filtros
                            </v-btn>
                            <v-btn color="warning" variant="outlined" size="small" :loading="cjPending.loading" @click="getCjPendingPayments">
                                Refrescar CJ
                            </v-btn>
                            <v-btn color="primary" size="small" @click="dialogCjPending = true">
                                Ver pendientes CJ
                            </v-btn>
                            <v-btn color="primary" size="small" @click="openCjWebhookLogsDialog">
                                Ver logs webhook CJ
                            </v-btn>
                        </div>
                    </div>

                    <v-dialog v-model="dialogCjPending" max-width="1100px">
                        <v-card>
                            <v-card-title class="d-flex justify-space-between align-center">
                                <span>Pedidos pagados pendientes de pago en CJ</span>
                                <v-btn icon variant="text" @click="dialogCjPending = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-alert type="info" variant="tonal" class="mb-4">
                                    Estado para cliente: <strong>Pagado</strong>. Este panel muestra solo incidencias internas de sincronización con CJ.
                                </v-alert>

                                <div class="d-flex align-center justify-space-between mb-3" style="gap: 12px; flex-wrap: wrap;">
                                    <v-text-field
                                        v-model="cjPendingSearch"
                                        density="compact"
                                        variant="outlined"
                                        hide-details
                                        prepend-inner-icon="mdi-magnify"
                                        placeholder="Buscar por order, email, estado, acción..."
                                        style="max-width: 420px;"
                                    ></v-text-field>
                                    <v-select
                                        v-model="cjStatusFilter"
                                        :items="cjStatusFilterOptions"
                                        density="compact"
                                        variant="outlined"
                                        hide-details
                                        label="Filtrar estado CJ"
                                        style="max-width: 280px;"
                                    ></v-select>
                                    <v-chip color="info" variant="tonal">
                                        Mostrando: {{ filteredCjPendingRows.length }}
                                    </v-chip>
                                </div>

                                <v-card variant="tonal" class="mb-3">
                                    <v-card-title class="text-subtitle-1">Leyenda estados CJ</v-card-title>
                                    <v-card-text>
                                        <div class="d-flex align-center" style="gap: 8px; flex-wrap: wrap;">
                                            <v-chip
                                                v-for="item in cjStatusLegend"
                                                :key="item.code"
                                                size="small"
                                                variant="outlined"
                                                :color="item.color"
                                            >
                                                {{ item.code }}: {{ item.label }}
                                            </v-chip>
                                        </div>
                                    </v-card-text>
                                </v-card>

                                <div class="d-flex align-center mb-3" style="gap: 8px; flex-wrap: wrap;">
                                    <v-chip color="warning" variant="tonal">Abiertos: {{ cjPending.metrics.open_pending }}</v-chip>
                                    <v-chip color="primary" variant="tonal">Creados 24h: {{ cjPending.metrics.created_24h }}</v-chip>
                                    <v-chip color="success" variant="tonal">Resueltos 24h: {{ cjPending.metrics.resolved_24h }}</v-chip>
                                    <v-chip color="secondary" variant="tonal">Reintentos 24h: {{ cjPending.metrics.retry_24h }}</v-chip>
                                    <v-chip color="deep-orange" variant="tonal">Reabiertas 24h: {{ cjPending.metrics.reopened_24h }}</v-chip>
                                </div>

                                <v-alert v-if="cjPending.resolvedIncidents.length > 0" type="success" variant="tonal" class="mb-3">
                                    Cierres recientes de incidencias CJ (24h): {{ cjPending.resolvedIncidents.length }}
                                </v-alert>

                                <v-table v-if="cjPending.resolvedIncidents.length > 0" density="compact" class="mb-4">
                                    <thead>
                                        <tr>
                                            <th>Order</th>
                                            <th>Estado CJ al cierre</th>
                                            <th>Origen</th>
                                            <th>Fecha cierre</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in cjPending.resolvedIncidents" :key="(item.order_id || 'x') + '-' + item.resolved_at">
                                            <td>{{ item.order_number || ('#' + item.order_id) }}</td>
                                            <td>
                                                <v-chip
                                                    size="x-small"
                                                    :color="cjStatusColor(item.cj_current_status)"
                                                    variant="tonal"
                                                >
                                                    {{ item.cj_current_status || '-' }}
                                                </v-chip>
                                            </td>
                                            <td>{{ item.source || '-' }}</td>
                                            <td>{{ item.resolved_at || '-' }}</td>
                                        </tr>
                                    </tbody>
                                </v-table>

                                <v-table density="compact">
                                    <thead>
                                        <tr>
                                            <th>Order</th>
                                            <th>Usuario</th>
                                            <th>Total</th>
                                            <th>Estado</th>
                                            <th>Estado actual CJ</th>
                                            <th>CJ Sync</th>
                                            <th>Tipo incidencia</th>
                                            <th>Acción CJ</th>
                                            <th>Fecha log</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in filteredCjPendingRows" :key="row.order_id + '-' + row.logged_at">
                                            <td>{{ row.order_number || ('#' + row.order_id) }}</td>
                                            <td>{{ row.user_email || '-' }}</td>
                                            <td>{{ row.total ?? '-' }}</td>
                                            <td>{{ row.customer_visible_status || row.order_status || '-' }}</td>
                                            <td>
                                                <v-chip
                                                    size="x-small"
                                                    :color="cjStatusColor(row.cj_current_status)"
                                                    variant="tonal"
                                                >
                                                    {{ row.cj_current_status || '-' }}
                                                </v-chip>
                                            </td>
                                            <td>{{ row.cj_sync_status || '-' }}</td>
                                            <td>
                                                <v-chip
                                                    size="x-small"
                                                    :color="eventTypeColor(row.event_type)"
                                                    variant="tonal"
                                                >
                                                    {{ eventTypeLabel(row.event_type) }}
                                                </v-chip>
                                            </td>
                                            <td>{{ row.cj_pending_action || '-' }}</td>
                                            <td>{{ row.logged_at || '-' }}</td>
                                            <td>
                                                <v-btn
                                                    color="success"
                                                    size="x-small"
                                                    variant="text"
                                                    :loading="Boolean(cjPending.retryingByOrder[row.order_id])"
                                                    @click="retryCjPendingByOrder(row.order_id)"
                                                >
                                                    Reintentar
                                                </v-btn>
                                                <v-btn color="primary" size="x-small" variant="text" @click="edit({ id: row.order_id })">
                                                    Abrir pedido
                                                </v-btn>
                                            </td>
                                        </tr>
                                        <tr v-if="!cjPending.loading && filteredCjPendingRows.length === 0">
                                            <td colspan="10" class="text-center">No hay pendientes de pago en CJ.</td>
                                        </tr>
                                    </tbody>
                                </v-table>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="dialogCjWebhookLogs" max-width="1000px">
                        <v-card>
                            <v-card-title class="d-flex justify-space-between align-center">
                                <span>Incidencias del webhook CJ (ORDERSPLIT / LOGISTIC)</span>
                                <v-btn icon variant="text" @click="dialogCjWebhookLogs = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-alert type="info" variant="tonal" class="mb-4">
                                    El webhook siempre responde 200 a CJ (para no arriesgar que lo desactive), así que estos
                                    avisos solo se ven aquí, nunca como error visible para CJ. Un WARNING es una incidencia
                                    parcial (firma inválida, pedido/paquete no correlacionado); un ERROR es una excepción real
                                    procesando el evento.
                                </v-alert>

                                <div class="d-flex align-center justify-space-between mb-3" style="gap: 12px; flex-wrap: wrap;">
                                    <v-select
                                        v-model="cjWebhookLogsLevelFilter"
                                        :items="[
                                            { title: 'Todos', value: 'ALL' },
                                            { title: 'Solo WARNING', value: 'WARNING' },
                                            { title: 'Solo ERROR', value: 'ERROR' },
                                        ]"
                                        density="compact"
                                        variant="outlined"
                                        hide-details
                                        label="Nivel"
                                        style="max-width: 220px;"
                                        @update:model-value="getCjWebhookLogs"
                                    ></v-select>
                                    <v-btn color="warning" variant="outlined" size="small" :loading="cjWebhookLogs.loading" @click="getCjWebhookLogs">
                                        Refrescar
                                    </v-btn>
                                </div>

                                <v-table density="compact">
                                    <thead>
                                        <tr>
                                            <th>Nivel</th>
                                            <th>Fecha</th>
                                            <th>Mensaje</th>
                                            <th>Contexto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in cjWebhookLogs.rows" :key="row.fecha + '-' + index">
                                            <td>
                                                <v-chip size="x-small" :color="row.nivel === 'ERROR' ? 'error' : 'warning'" variant="tonal">
                                                    {{ row.nivel }}
                                                </v-chip>
                                            </td>
                                            <td>{{ row.fecha }}</td>
                                            <td>{{ row.mensaje }}</td>
                                            <td>
                                                <pre style="white-space: pre-wrap; font-size: 11px; margin: 0;">{{ formatWebhookLogContext(row.contexto) }}</pre>
                                            </td>
                                        </tr>
                                        <tr v-if="!cjWebhookLogs.loading && cjWebhookLogs.rows.length === 0">
                                            <td colspan="4" class="text-center">Sin incidencias registradas.</td>
                                        </tr>
                                    </tbody>
                                </v-table>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <div class="table-responsive table-desi table-product">
                        <v-data-table-server
                            class="table table-1d all-package blogGrid"
                            v-model:page="pagination.current"
                            v-model:items-per-page="itemsPerPage"
                            :search="search"
                            :headers="showHeaders"
                            :items-length="pagination.total"
                            :items="dataGrid"
                            :loading="loading"
                            item-value="name"
                            @update:options="handleTableOptionsUpdate"
                        >
                            <template v-slot:thead>
                                <tbody>
                                    <tr>
                                        <td v-if="selectedHeaders.includes('orderNumber')">
                                            <v-text-field v-model="orderNumber" hide-details placeholder="Search order number..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('user')">
                                            <v-text-field v-model="user" hide-details placeholder="Search email..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('city')">
                                            <v-text-field v-model="city" hide-details placeholder="Search city..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('address')">
                                            <v-text-field v-model="address" hide-details placeholder="Search address..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('addressNumber')">
                                            <v-text-field v-model="addressNumber" hide-details placeholder="Search address number..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('orderStatus')">
                                            <!-- <v-text-field v-model="orderStatus" hide-details placeholder="Search order status..." class="ma-2" density="compact"></v-text-field>
                                             -->
                                            <v-combobox
                                                v-model="orderStatus"
                                                :items="orderStatusOptions" 
                                                item-title="name"
                                                item-value="id"
                                                hide-details
                                                placeholder="Select order status..."
                                                class="ma-2"
                                                density="compact"
                                            ></v-combobox>
                                        </td>
                                        <td v-if="selectedHeaders.includes('total')">
                                            <v-text-field v-model="total" hide-details placeholder="Search total..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('actions')"></td>
                                    </tr>
                                </tbody>
                            </template>
                            <template v-slot:item.orderStatus="{ item }">
                                <span>{{ item.orderStatus?.name }}</span>
                            </template>
                            <template v-slot:item.user="{ item }">
                                <span>{{ item.user?.email }}</span>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-btn color="primary" class="elevation-0" icon variant="plain" @click="edit(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn>
                               <!-- <v-btn color="error"   class="elevation-0" icon variant="plain" @click="openDeleteDialog(item)"><v-icon> mdi-trash-can-outline </v-icon> </v-btn> -->

                                <v-dialog v-model="dialogDelete" max-width="600px">
                                    <v-card>
                                        <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                        <v-card-text> Are you sure you want to delete the vendor with the name '{{ selectedItem.name }}'? </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="red"   text @click="dialogDelete = false">Cancel</v-btn>
                                             <v-btn color="green" text @click="deleteItem(selectedItem)">Delete</v-btn> 
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-data-table-server>
                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    title: 'Vendors',
    props: {},
    data() {
        return {
            dataGrid: [],
            pagination: {
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            },
            itemsPerPage: 10,
            tableOptions: {
                page: 1,
                itemsPerPage: 10,
                sortBy: []
            },
            filterDebounceId: null,
            selectedHeaders: ['orderNumber', 'user', 'city', 'address', 'addressNumber',  'orderStatus', 'total','actions'],
            headers: [
                {
                    title: 'Order Number',
                    align: 'start',
                    sortable: true,
                    key: 'orderNumber'
                },
                {
                    title: 'User email',
                    align: 'start',
                    sortable: true,
                    key: 'user'
                },
                {
                    title: 'City',
                    align: 'center',
                    sortable: true,
                    key: 'city'
                },
                {
                    title: 'Address',
                    align: 'center',
                    sortable: true,
                    key: 'address'
                },
                {
                    title: 'Address Number',
                    align: 'center',
                    sortable: true,
                    key: 'addressNumber'
                },
                
                {
                    title: 'Order Status',
                    align: 'center',
                    sortable: true,
                    key: 'orderStatus'
                },
            
                {
                    title: 'Total',
                    align: 'center',
                    sortable: true,
                    key: 'total'
                },
                {
                    title: 'Actions',
                    align: 'center',
                    sortable: false,
                    key: 'actions'
                }
            ],
            loading: true,

            // Filtros search
            search: '',
            id: '',
            orderNumber: '',
            city: '',
            user: '',
            address: '',
            addressNumber: '',
            orderStatus: '',
            orderStatusOptions: [],
            total: '',

            selectedItem: null,
            dialogDelete: false,
            messageError: '',
            typeOfMessage: '',

            dialogCjPending: false,
            cjPendingSearch: '',
            cjStatusFilter: 'ALL',
            cjStatusFilterOptions: [
                { title: 'Todos los estados', value: 'ALL' },
                { title: 'Pendientes CJ (CREATED / IN_CART / UNPAID)', value: 'PENDING_GROUP' },
                { title: 'No pendientes CJ', value: 'NON_PENDING_GROUP' },
                { title: 'Errores/Desconocido (ERROR / UNKNOWN)', value: 'ERROR_GROUP' },
                { title: 'CREATED', value: 'CREATED' },
                { title: 'IN_CART', value: 'IN_CART' },
                { title: 'UNPAID', value: 'UNPAID' },
                { title: 'UNSHIPPED', value: 'UNSHIPPED' },
                { title: 'SHIPPED', value: 'SHIPPED' },
                { title: 'DELIVERED', value: 'DELIVERED' },
                { title: 'CANCELLED', value: 'CANCELLED' },
                { title: 'TRASH', value: 'TRASH' },
                { title: 'UNKNOWN', value: 'UNKNOWN' },
                { title: 'ERROR', value: 'ERROR' },
            ],
            cjStatusLegend: [
                { code: 'CREATED', label: 'Pedido creado en CJ, aun no pagado en CJ.', color: 'warning' },
                { code: 'IN_CART', label: 'Pedido en carrito CJ, pendiente de completar pago en CJ.', color: 'warning' },
                { code: 'UNPAID', label: 'Pedido confirmado pero pendiente de pago en CJ.', color: 'warning' },
                { code: 'UNSHIPPED', label: 'Pedido pagado en CJ y listo para gestion logistica.', color: 'info' },
                { code: 'SHIPPED', label: 'Pedido enviado por CJ.', color: 'primary' },
                { code: 'DELIVERED', label: 'Pedido entregado al cliente final.', color: 'success' },
                { code: 'CANCELLED', label: 'Pedido cancelado.', color: 'error' },
                { code: 'TRASH', label: 'Pedido descartado/eliminado en CJ.', color: 'error' },
                { code: 'UNKNOWN', label: 'Estado no informado por CJ o no mapeado.', color: 'secondary' },
                { code: 'ERROR', label: 'Error consultando estado CJ.', color: 'secondary' },
            ],
            cjPending: {
                loading: false,
                total: 0,
                rows: [],
                resolvedIncidents: [],
                retryingByOrder: {},
                metrics: {
                    open_pending: 0,
                    created_24h: 0,
                    resolved_24h: 0,
                    retry_24h: 0,
                    reopened_24h: 0,
                }
            },
            dialogCjWebhookLogs: false,
            cjWebhookLogsLevelFilter: 'ALL',
            cjWebhookLogs: {
                loading: false,
                total: 0,
                rows: [],
            }
        }
    },
    watch: {
        id() {
            this.queueGridReload()
        },
        orderNumber() {
            this.queueGridReload()
        },
        city() {
            this.queueGridReload()
        },
        user() {
            this.queueGridReload()
        },
        address() {
            this.queueGridReload()
        },
        addressNumber() {
            this.queueGridReload()
        },
        orderStatus() {
            this.queueGridReload()
        },
        total() {
            this.queueGridReload()
        },
    },
    computed: {
        //Done to get the ordered headers
        showHeaders() {
            return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
        },
        filteredCjPendingRows() {
            const rows = Array.isArray(this.cjPending?.rows) ? this.cjPending.rows : []
            const term = (this.cjPendingSearch || '').toString().trim().toLowerCase()
            const statusFilter = (this.cjStatusFilter || 'ALL').toString().toUpperCase()

            const matchesStatus = (row) => {
                const status = (row?.cj_current_status || 'UNKNOWN').toString().toUpperCase()

                if (statusFilter === 'ALL') {
                    return true
                }

                if (statusFilter === 'PENDING_GROUP') {
                    return ['CREATED', 'IN_CART', 'UNPAID'].includes(status)
                }

                if (statusFilter === 'NON_PENDING_GROUP') {
                    return !['CREATED', 'IN_CART', 'UNPAID', 'UNKNOWN', 'ERROR'].includes(status)
                }

                if (statusFilter === 'ERROR_GROUP') {
                    return ['UNKNOWN', 'ERROR'].includes(status)
                }

                return status === statusFilter
            }

            return rows.filter((row) => {
                if (!matchesStatus(row)) {
                    return false
                }

                if (!term) {
                    return true
                }

                const haystack = [
                    row.order_number,
                    row.order_id,
                    row.user_email,
                    row.order_status,
                    row.customer_visible_status,
                    row.cj_current_status,
                    row.cj_sync_status,
                    row.cj_pending_action,
                    row.logged_at
                ]
                    .filter((value) => value !== null && value !== undefined)
                    .join(' ')
                    .toLowerCase()

                return haystack.includes(term)
            })
        }
    },
    methods: {
        handleTableOptionsUpdate(options = {}) {
            const nextPage = Number(options.page || this.pagination.current || 1)
            const nextItemsPerPage = Number(options.itemsPerPage || this.itemsPerPage || 10)
            const nextSortBy = Array.isArray(options.sortBy) ? options.sortBy : []

            this.pagination.current = nextPage
            this.itemsPerPage = nextItemsPerPage

            return this.getGrid({
                page: nextPage,
                itemsPerPage: nextItemsPerPage,
                sortBy: nextSortBy
            })
        },
        queueGridReload() {
            if (this.filterDebounceId) {
                clearTimeout(this.filterDebounceId)
            }

            this.filterDebounceId = setTimeout(() => {
                this.tableOptions = {
                    ...this.tableOptions,
                    page: 1,
                }

                this.getGrid(this.tableOptions)
            }, 350)
        },
        buildGridQuery({ page, itemsPerPage, sortBy }) {
            const params = new URLSearchParams({
                page: String(page || 1),
                limit: String(itemsPerPage || this.itemsPerPage),
                id: this.id || ''
            })

            if (this.orderNumber) {
                params.set('order_number', this.orderNumber)
            }

            if (this.city) {
                params.set('city', this.city)
            }

            if (this.user) {
                params.set('email_user', this.user)
            }

            if (this.address) {
                params.set('address', this.address)
            }

            if (this.addressNumber) {
                params.set('address_number', this.addressNumber)
            }

            if (this.orderStatus && typeof this.orderStatus === 'object' && this.orderStatus.id) {
                params.set('order_status', this.orderStatus.id)
            }

            if (this.total) {
                params.set('total', this.total)
            }

            const sortFieldMap = {
                orderNumber: 'order_number',
                user: 'email_user',
                city: 'city',
                address: 'address',
                addressNumber: 'address_number',
                orderStatus: 'order_status',
                total: 'total',
            }

            if (Array.isArray(sortBy) && sortBy[0]?.key) {
                const sortKey = sortFieldMap[sortBy[0].key]
                if (sortKey) {
                    params.set('sort', sortKey)
                    params.set('order', sortBy[0].order || 'asc')
                }
            }

            return `${process.env.VUE_APP_URL_API_BASE}/admin/order/grid?${params.toString()}`
        },
        cjStatusColor(status) {
            const normalized = (status || 'UNKNOWN').toString().toUpperCase()

            if (['CREATED', 'IN_CART', 'UNPAID'].includes(normalized)) {
                return 'warning'
            }

            if (['UNSHIPPED'].includes(normalized)) {
                return 'info'
            }

            if (['SHIPPED'].includes(normalized)) {
                return 'primary'
            }

            if (['DELIVERED'].includes(normalized)) {
                return 'success'
            }

            if (['CANCELLED', 'TRASH'].includes(normalized)) {
                return 'error'
            }

            return 'secondary'
        },
        eventTypeLabel(eventType) {
            const normalized = (eventType || '').toString().toLowerCase()

            if (normalized === 'pending_reopened') {
                return 'Reabierta'
            }

            if (normalized === 'pending_retry') {
                return 'Reintento'
            }

            if (normalized === 'pending_detected') {
                return 'Detectada'
            }

            return 'Detectada'
        },
        eventTypeColor(eventType) {
            const normalized = (eventType || '').toString().toLowerCase()

            if (normalized === 'pending_reopened') {
                return 'deep-orange'
            }

            if (normalized === 'pending_retry') {
                return 'secondary'
            }

            return 'warning'
        },
        async resetFilters() {
            this.id = ''
            this.orderNumber = ''
            this.city = ''
            this.user = ''
            this.address = ''
            this.addressNumber = ''
            this.orderStatus = ''
            this.total = ''

            this.tableOptions = {
                ...this.tableOptions,
                page: 1,
                itemsPerPage: this.itemsPerPage,
                sortBy: []
            }

            await this.getGrid(this.tableOptions)
        },
        openDeleteDialog(item) {
            this.selectedItem = item;
            this.dialogDelete = true;
        },
        getListOrderStatus() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/order-status/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.orderStatusOptions = []
                        self.orderStatusOptions = response.data
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        async getCjPendingPayments() {
            this.cjPending.loading = true
            try {
                const response = await axios({
                    url: process.env.VUE_APP_URL_API_BASE + '/admin/order/cj-pending-payment?limit=50',
                    method: 'GET',
                    responseType: 'json'
                })

                const payload = response?.data || {}
                this.cjPending.rows = Array.isArray(payload.data) ? payload.data : []
                this.cjPending.resolvedIncidents = Array.isArray(payload.resolved_incidents) ? payload.resolved_incidents : []
                this.cjPending.total = Number(payload.total || this.cjPending.rows.length || 0)
                this.cjPending.metrics = {
                    open_pending: Number(payload.metrics?.open_pending || this.cjPending.total || 0),
                    created_24h: Number(payload.metrics?.created_24h || 0),
                    resolved_24h: Number(payload.metrics?.resolved_24h || 0),
                    retry_24h: Number(payload.metrics?.retry_24h || 0),
                    reopened_24h: Number(payload.metrics?.reopened_24h || 0),
                }
            } catch (error) {
                this.cjPending.rows = []
                this.cjPending.resolvedIncidents = []
                this.cjPending.total = 0
                this.cjPending.metrics = {
                    open_pending: 0,
                    created_24h: 0,
                    resolved_24h: 0,
                    retry_24h: 0,
                    reopened_24h: 0,
                }
            } finally {
                this.cjPending.loading = false
            }
        },
        openCjWebhookLogsDialog() {
            this.dialogCjWebhookLogs = true
            this.getCjWebhookLogs()
        },
        formatWebhookLogContext(contexto) {
            if (!contexto || typeof contexto !== 'object') {
                return '-'
            }
            return JSON.stringify(contexto, null, 2)
        },
        async getCjWebhookLogs() {
            this.cjWebhookLogs.loading = true
            try {
                const nivel = this.cjWebhookLogsLevelFilter && this.cjWebhookLogsLevelFilter !== 'ALL'
                    ? `&nivel=${this.cjWebhookLogsLevelFilter}`
                    : ''
                const response = await axios({
                    url: `${process.env.VUE_APP_URL_API_BASE}/admin/order/cj-webhook-logs?limit=100${nivel}`,
                    method: 'GET',
                    responseType: 'json'
                })

                const payload = response?.data || {}
                this.cjWebhookLogs.rows = Array.isArray(payload.data) ? payload.data : []
                this.cjWebhookLogs.total = Number(payload.total || this.cjWebhookLogs.rows.length || 0)
            } catch (error) {
                this.cjWebhookLogs.rows = []
                this.cjWebhookLogs.total = 0
            } finally {
                this.cjWebhookLogs.loading = false
            }
        },
        async retryCjPendingByOrder(orderId) {
            if (!orderId) {
                return
            }

            this.cjPending.retryingByOrder = {
                ...this.cjPending.retryingByOrder,
                [orderId]: true,
            }

            try {
                const response = await axios({
                    url: `${process.env.VUE_APP_URL_API_BASE}/admin/order/cj-retry-pending/${orderId}`,
                    method: 'POST',
                    responseType: 'json'
                })

                this.messageError = response?.data?.message || 'Reintento CJ ejecutado.'
                this.typeOfMessage = response?.data?.resolved ? 'success' : 'warning'
                setTimeout(() => (this.messageError = ''), 10000)

                await this.getCjPendingPayments()
            } catch (error) {
                this.messageError = 'Error al reintentar sincronizacion CJ para el pedido.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
            } finally {
                this.cjPending.retryingByOrder = {
                    ...this.cjPending.retryingByOrder,
                    [orderId]: false,
                }
            }
        },
        async getGrid(options = {}) {
            const page = options.page || this.tableOptions.page || 1
            const itemsPerPage = options.itemsPerPage || this.tableOptions.itemsPerPage || this.itemsPerPage
            const sortBy = Array.isArray(options.sortBy) ? options.sortBy : this.tableOptions.sortBy

            this.pagination.current = page
            this.itemsPerPage = Number(itemsPerPage || this.itemsPerPage || 10)
            this.tableOptions = {
                page,
                itemsPerPage: this.itemsPerPage,
                sortBy: sortBy || []
            }

            this.loading = true
            try {
                const response = await axios({
                    url: this.buildGridQuery({ page, itemsPerPage: this.itemsPerPage, sortBy }),
                    method: 'GET',
                    responseType: 'json'
                })

                const payload = response?.data || {}
                this.dataGrid = Array.isArray(payload.data) ? payload.data.filter(Boolean) : []
                this.pagination.from = payload.from || 0
                this.pagination.to = payload.to || 0
                this.pagination.total = payload.total || 0
                this.pagination.current = payload.current_page || page
                this.pagination.lastPage = payload.last_page || 0
                this.messageError = ''
                this.typeOfMessage = ''

                return 'Success'
            } catch (error) {
                this.dataGrid = []
                this.pagination.from = 0
                this.pagination.to = 0
                this.pagination.total = 0
                this.pagination.current = page
                this.pagination.lastPage = 0
                this.messageError = 'Error cargando el listado de pedidos.'
                this.typeOfMessage = 'error'

                return 'Error'
            } finally {
                this.loading = false
            }
        },
        edit(item) {
            this.$router.push({ path: "edit_order/" + item.id });
        },

        //De momento no se eliminan
        async deleteItem(item)  {
            let newObject = {
                id: item.id
            }
            await axios.post('http://localhost:8001/admin/order/delete', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }

                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha eliminado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
            })

            let paramsGrid = {
                page: this.pagination.current ,
                itemsPerPage: this.itemsPerPage
            }
            await this.getGrid(paramsGrid); 
            this.dialogDelete = false;
        }
    },
     mounted() {
         this.getListOrderStatus()
         this.getCjPendingPayments()
         this.getCjWebhookLogs()
         this.getGrid(this.tableOptions)
        //this.cargado=true 
    }
    ,beforeUnmount() {
        if (this.filterDebounceId) {
            clearTimeout(this.filterDebounceId)
        }
    }
    /* async mounted() {
        await this.getGrid()
    }  */
}
</script>

<style></style>
